'use client';
import { useMemo } from 'react';
import styles from './progressive-leasing.module.scss';
import { buildEstimatorURL } from './helpers';

type Props = {
  price: number;
  stateId?: string;
  position?: number;
  page?: string;
  isPDPRedesign?: boolean;
};

export const ProgressiveLeasing = ({ price, stateId }: Props) => {
  const src = useMemo(
    () => buildEstimatorURL(price, stateId),
    [price, stateId],
  );

  return (
    <section className={styles.section}>
      <iframe
        title="modal"
        className="msc-modal__iframe"
        sandbox="allow-popups allow-scripts allow-same-origin"
        src={src}
      />
    </section>
  );
};
